import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

export const right = (props) => {
  return <ChevronRightRoundedIcon {...props} />;
};
